// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empassetspage-inline-1 {
  text-align: center;
  color: #94a3b8;
  padding: 20px;
  font-size: 13px;
}

.empassetspage-inline-2 {
  color: #94a3b8;
  font-size: 12px;
}

.empassetspage-inline-3 {
  color: #94a3b8;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpAssetsPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".empassetspage-inline-1 {\n  text-align: center;\n  color: #94a3b8;\n  padding: 20px;\n  font-size: 13px;\n}\n\n.empassetspage-inline-2 {\n  color: #94a3b8;\n  font-size: 12px;\n}\n\n.empassetspage-inline-3 {\n  color: #94a3b8;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
